



























import { Component, Vue } from 'vue-property-decorator';
import { getUrlParam } from '@/utils/common';
// import { copyText } from '@/utils/common';

const qjMainPic = require('../../../assets/images/merchant/merchant-activity/register_success_new_qiaoji.png');
const qjQrcodePic = require('../../../assets/images/merchant/alipay_qrcode_qiaoji.png');
const qjSearchPic = require('../../../assets/images/merchant/merchant-activity/alipay_search_qj.png');

const qzjMainPic = require('../../../assets/images/merchant/merchant-activity/register_success_new.png');
const qzjQrcodePic = require('../../../assets/images/merchant/alipay_qrcode.png');
const qzjSearchPic = require('../../../assets/images/merchant/merchant-activity/alipay_search_qzj.png');


@Component({
  name: 'NewRegisterSuccess'
})

export default class NewRegisterSuccess extends Vue {
  mainPic = '';
  qrcodePic = '';
  searchPic = '';

  created() {
    const isQzj = getUrlParam('isQzj');

    if (isQzj === 'true') {
      document.title = '俏租机';
      this.mainPic = qzjMainPic;
      this.qrcodePic = qzjQrcodePic;
      this.searchPic = qzjSearchPic;
    } else {
      document.title = '俏机';
      this.mainPic = qjMainPic;
      this.qrcodePic = qjQrcodePic;
      this.searchPic = qjSearchPic;
    }
  }

  /*copyMpCode() {
    // 复制支口令
    copyText('3# wa:/EwC2Xh399mw#@此消息，👍支宝👈搜索，体验俏租机小程序');
  }*/
}
